class Elements {
    /**
     * Handy container for caching elements and fetching new ones.
     * 
     * Automatically converts NodeList's or Array like objects returned by querySelectorAll into actual Arrays.
     * 
     * @param root - Optional root scope element, from which all querys will be run beneath.
     */
    constructor(root = null) {
        if ( ! root) {
            root = document;
        }

        this.queries = {
            queryOne: { },
            queryAll: { }
        };
        
        this.root = root;
        this.elements = { };
    }

    /**
     * Return the object containing all saved elements.
     * 
     * @returns {{}}
     */
    all() {
        return this.elements;
    }

    /**
     * Check if this instance has an element saved under the given name.
     * 
     * @param name
     * @returns {boolean}
     */
    has(name) {
        return !! this.elements[name];
    }

    /**
     * Get an element with the given name, with an optional default.
     * 
     * @param name
     * @param defaultElement
     * @returns {*}
     */
    get(name, defaultElement) {
        if (this.has(name)) {
            return this.elements[name];
        }

        return defaultElement;
    }
    
    each(name, callback) {
        this.get(name).forEach(callback);
    }

    /**
     * Save a given element or set of elements under the given name.
     * 
     * @param name
     * @param element
     * @returns {*}
     */
    save(name, element) {
        if (element) {
            this.elements[name] = element;
            
            return element;
        }
    }

    /**
     * Get scope for perform query under.
     * 
     * @param name
     * @returns {*}
     */
    scope(name) {
        return this.get(name, this.root);
    }

    /**
     * Gets first matching element.
     * 
     * @param {string} name
     * @param {string} selector
     * @param parent - Limit query to scope, can be 
     */
    queryOne(name, selector, parent = null) {
        // Track queries
        this.queries.queryOne[name] = [selector, parent];
        
        return this.save(
            name,
            this.scope(parent).querySelector(selector)
        );
    }

    /**
     * Gets all matching elements.
     * 
     * @param {string} name
     * @param {string} selector
     * @param parent
     */
    queryAll(name, selector, parent = null) {
        // Track queries
        this.queries.queryAll[name] = [selector, parent];
        
        return this.save(
            name,
            Array.from(this.scope(parent).querySelectorAll(selector))
        );
    }
    
    updateQueriesOfType(queryStore, type) {
        let name,
            selector,
            parent;
        
        for (name in queryStore) {
            [selector, parent] = queryStore[name];
            
            this[type].call(this, name, selector, parent);
        }
    }
    
    updateQueries() {
        Object.keys(this.queries).forEach(
            type => this.updateQueriesOfType(this.queries[type], type)
        );
    }

    /**
     * Destroy the instance.
     */
    destroy() {
        this.root = null;
        this.elements = null;
    }
}

export default Elements;